import { IOption } from '@vtbhome/juicyfront/types';
import { PreloaderOption } from '../../../ui/register-step/register-step.styles';
import { Preloader } from '@vtbhome/juicyfront';

export const LOADING_OPTION: IOption[] = [
    {
        label: 'loading',
        value: 'loading',
        disabled: true,
        node: (
            <PreloaderOption>
                <Preloader />
            </PreloaderOption>
        ),
    },
];
